module.exports = __webpack_public_path__ + "img/FTP.56a9679a.png";